module.exports = __webpack_public_path__ + "img/2022-09.ba34454e.jpg";